import useProductDetailsData from "hook/useProductDetailsData";
import useProductsByCatalogue from "hook/useProductsByCatalogue";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { FaTruck } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { MdOutlineZoomOutMap } from "react-icons/md";
import ImageMagnifier from "components/commonComponent/ImageMagnifier";
import ProductSwiper from "components/commonComponent/productSwiper";
import newIcon from "images/box.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ProductDetailsShimmer } from "components/shimmer/productDetailsShimmer";
import FooterSection from "assets/Footer";
import ScrollToTopButton from "components/ScrollToTopButton";
import { IoMdShareAlt } from "react-icons/io";
import ProblemAndDelivery from "components/productDetailsComponent/problem&Delivery";
import { getColorCode } from "utils/color";
import VariantSelector from "components/productDetailsComponent/VariantSelector";
import { assetUrl } from "utils/api";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import { getCartItems, setCartItems } from "utils/cartStorage";
import {fbTrack} from "../utils/fbPixel";

const ProductDetails = () => {
  const { category, id } = useParams();
  const { products, loading, error } = useProductsByCatalogue(category);
  const [sizes, setSizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState("");
  const [colors, setColors] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const { detailsData, loadingDetails } = useProductDetailsData(id);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [showZoom, setShowZoom] = useState(false);
  const { theme, language } = useSettings();
  const isDark = theme === "dark";
  /* ---------------- INITIAL LOAD ---------------- */
  useEffect(() => {
    if (!detailsData) return;
    if (detailsData.size) {
      const sizeArray = detailsData.size?.split(",").map((s) => s.trim()) || [];
      setSizes(sizeArray);
      setSelectedSize(sizeArray[0]);
    }
    if (detailsData.color) {
      const colorArray =
        detailsData.color?.split(",").map((c) => c.trim()) || [];
      setColors(colorArray);
      setSelectedColor(colorArray[0]);
    }
    if (detailsData.variants?.length) {
      setVariants(detailsData.variants);

      const firstVariant = detailsData.variants[0];
      setSelectedVariant(firstVariant);
      setSelectedImage({
        type: "image",
        variant: firstVariant,
        thumb: assetUrl(firstVariant.images[0].thumb),
        original: assetUrl(firstVariant.images[0].original),
        src: assetUrl(firstVariant.images[0].original),
      });
    }
  }, [detailsData]);

  // useEffect(() => {
  //   if (!detailsData || !selectedVariant) return;
  //
  //   window.dataLayer = window.dataLayer || [];
  //
  //   window.dataLayer.push({
  //     event: "view_item",
  //     ecommerce: {
  //       currency: "BDT",
  //       value: selectedVariant?.flashPrice || selectedVariant?.discount || 0,
  //       items: [
  //         {
  //           item_id: detailsData.item_id,
  //           item_name: selectedVariant.title,
  //           price:
  //             selectedVariant?.flashPrice || selectedVariant?.discount || 0,
  //           item_category: detailsData.catalogue_title,
  //           item_variant: selectedVariant.title,
  //         },
  //       ],
  //     },
  //   });
  //
  //   console.log("view_item fired");
  // }, [detailsData, selectedVariant]);

  useEffect(() => {
    if (!detailsData || !selectedVariant) return;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "view_item",
      ecommerce: {
        currency: "BDT",
        value: selectedVariant?.flashPrice || selectedVariant?.discount || 0,
        items: [
          {
            item_id: detailsData.item_id,
            item_name: selectedVariant.title,
            price:
                selectedVariant?.flashPrice || selectedVariant?.discount || 0,
            item_category: detailsData.catalogue_title,
            item_variant: selectedVariant.title,
          },
        ],
      },
    });

    fbTrack("ViewContent", {
      content_ids: [String(detailsData.item_id)],
      content_type: "product",
      content_name: selectedVariant.title,
      content_category: detailsData.catalogue_title,
      currency: "BDT",
      value: selectedVariant?.flashPrice || selectedVariant?.discount || 0,
    });

    console.log("view_item fired");
  }, [detailsData, selectedVariant]);

  if (loadingDetails) return <ProductDetailsShimmer />;

  const allMedia = [
    // Images from variants
    ...variants.flatMap((variant) =>
      variant.images.map((img) => ({
        type: "image",
        variant,
        thumb: assetUrl(img.thumb),
        original: assetUrl(img.original),
      })),
    ),

    // Videos from item
    ...(detailsData?.video_path || []).map((video) => ({
      type: "video",
      variant: variants[0], // attach first variant
      src: video,
    })),
  ];

  const product = detailsData;
  const isOutOfStock = product.status === "unavailable";
  const currentTitle = selectedVariant?.title;
  const currentPrice = selectedVariant?.discount || selectedVariant?.flashPrice;
  const originalPrice = selectedVariant?.flashPrice;
  const freeVariantDelivery = selectedVariant?.freeVariantDelivery;

  const discountPercent =
    currentPrice > 0
      ? Math.ceil(((currentPrice - originalPrice) / currentPrice) * 100)
      : 0;

  // const images = selectedVariant?.images || [];
  const currentImage =
    selectedImage?.type === "image"
      ? selectedImage.original || selectedImage.src || selectedImage.thumb || ""
      : selectedImage?.src || "";

  const whatsappMessage = `
    *${currentTitle}*
    Price: ${originalPrice}৳
    ${window.location.href}
    Thank You!
    `;

  const handleAddToCart = (e) => {
    e.stopPropagation();

    // ✅ FIRE ADD TO CART EVENT
    // const price = selectedVariant?.flashPrice || selectedVariant?.discount || 0;
    // window.dataLayer = window.dataLayer || [];
    //
    // window.dataLayer.push({
    //   event: "add_to_cart",
    //   ecommerce: {
    //     currency: "BDT",
    //     value: price * quantity,
    //     items: [
    //       {
    //         item_id: detailsData.item_id,
    //         item_name: selectedVariant.title,
    //         price: price,
    //         item_category: detailsData.catalogue_title,
    //         item_variant: selectedVariant.title,
    //         quantity: quantity,
    //       },
    //     ],
    //   },
    // });

    const price = selectedVariant?.flashPrice || selectedVariant?.discount || 0;
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "BDT",
        value: price * quantity,
        items: [
          {
            item_id: detailsData.item_id,
            item_name: selectedVariant.title,
            price: price,
            item_category: detailsData.catalogue_title,
            item_variant: selectedVariant.title,
            quantity: quantity,
          },
        ],
      },
    });

    fbTrack("AddToCart", {
      content_ids: [String(detailsData.item_id)],
      content_type: "product",
      content_name: selectedVariant.title,
      content_category: detailsData.catalogue_title,
      currency: "BDT",
      value: price * quantity,
    });

    console.log("add_to_cart fired");
    // Get existing cart from localStorage
    const cart = getCartItems();

    // Unique key per item + variant
    const key = `${detailsData.item_id}_${selectedVariant.variant_id}`;

    // Check if item already exists in cart
    const index = cart.findIndex((item) => item.cartKey === key);

    if (index !== -1) {
      // If exists, increase quantity
      cart[index].quantity += quantity;
    } else {
      // Push full item details into cart with cartKey
      cart.push({
        cartKey: key, // ✅ unique identifier
        item_id: detailsData.item_id,
        catalogue: detailsData.catalogue,
        catalogue_title: detailsData.catalogue_title,
        color: detailsData.color,
        description: detailsData.description,
        extraDescription: detailsData.extraDescription,
        flashOffer: detailsData.flashOffer,
        quantity: quantity,
        material: detailsData.material,
        selectedColor: selectedColor,
        selectedPrice: selectedVariant.flashPrice,
        selectedSize: selectedSize,
        selectedTitle: selectedVariant.title,
        selectedVariant: selectedVariant,
        size: detailsData.size,
        status: detailsData.status,
        subCatalogue: detailsData.subCatalogue,
        subCatalogue_title: detailsData.subCatalogue_title,
        variant: detailsData.variant,
        video_path: detailsData.video_path,
        image: currentImage, // main image for display
      });
    }

    // Save back to localStorage
    setCartItems(cart);
    toast.success(t("addedToCart", language));
    // Optional: update state if you show cart immediately
    // setProducts(cart);
  };

  // --- Order Handler ---
  const handleOrderNow = (e) => {
    handleAddToCart(e);
    navigate("/orderDetails");
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check this out!",
          text: "Look at this awesome product 👇",
          url: window.location.href, // current page URL
        });
      } catch (error) {
        console.log("Sharing failed:", error);
      }
    } else {
      alert("Sharing not supported on this browser");
    }
  };

  return (
    <div className="pb-20 md:pb-0">
      <Helmet>
        <meta property="og:title" content={currentTitle} />
        <meta
          property="og:description"
          content={`Buy ${currentTitle} for ${currentPrice}৳`}
        />
        <meta property="og:image" content={currentImage} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="product" />
      </Helmet>
      <div
        className={`${isDark ? "bg-gray-100" : "bg-white"} relative select-none min-h-screen`}
      >
        <div>
          <div className="relative md:max-w-7xl mx-auto sm:px-4 2xl:px-0 lg:px-8 md:pb-4 pb-0">
            <div
              className={`grid grid-cols-1 md:grid-cols-2 md:p-4 gap-6 ${isDark ? "bg-gray-100" : "bg-white"} rounded`}
            >
              {/* Left Panel */}
              <div className="relative w-full  items-center rounded-2xl lg:sticky lg:top-6 self-start lg:border lg:border-gray-200 lg:bg-white lg:p-4 lg:shadow-sm">
                {currentImage &&
                  // <ImageMagnifier src={currentImage} alt={currentTitle} />
                  (selectedImage?.type === "image" ? (
                    <ImageMagnifier
                      src={currentImage}
                      alt={currentTitle}
                      showZoom={showZoom}
                      setShowZoom={setShowZoom}
                      wrapperClassName="aspect-[4/5] lg:aspect-[4/5]"
                    />
                  ) : (
                    // <div className="relative inline-block">
                    <div className="relative w-full aspect-[4/5] overflow-hidden rounded-2xl bg-black lg:aspect-[4/5]">
                      <video
                        src={currentImage}
                        controls
                        controlsList="nodownload noplaybackrate"
                        onContextMenu={(e) => e.preventDefault()}
                        className="w-full h-full object-contain"
                      />
                    </div>
                  ))}
                <div
                  className="absolute top-3 right-3 bg-white shadow-lg border border-gray-200 p-2 rounded-full"
                  onClick={handleShare}
                >
                  <IoMdShareAlt size={12} className="text-primary-600" />
                </div>
                <div
                  className="absolute top-3 left-3 bg-white shadow-lg border border-gray-200 p-2 rounded-full"
                  onClick={() => setShowZoom(true)}
                >
                  <MdOutlineZoomOutMap size={12} />
                </div>
                {/* Thumbnail Images */}
                {allMedia.length > 1 && (
                  <div className=" w-full px-2">
                    <div className="mx-auto w-fit max-w-full bg-white/90 backdrop-blur-md shadow-xl rounded-xl px-3 py-2 flex gap-2 overflow-x-auto scrollbar-hide">
                      {allMedia.map((item, idx) => {
                        const url =
                          item.type === "image" ? item.thumb : item.src;
                        const isSelected =
                          item.type === "image"
                            ? selectedImage?.original === item.original
                            : selectedImage?.src === item.src;

                        return item.type === "image" ? (
                          <img
                            key={idx}
                            alt={`Thumb ${idx}`}
                            src={url}
                            loading="lazy"
                            decoding="async"
                            className={`w-16 h-16 object-cover rounded-md cursor-pointer border-2 ${
                              isSelected
                                ? "border-primary-500"
                                : "border-transparent"
                            }`}
                            onClick={() => {
                              setSelectedVariant(item.variant);
                              setSelectedImage(item);
                            }}
                          />
                        ) : (
                          <div
                            key={idx}
                            className={`relative w-20 h-20 border-2 rounded-md cursor-pointer overflow-hidden ${
                              isSelected
                                ? "border-primary-500"
                                : "border-transparent"
                            }`}
                            onClick={() => {
                              setSelectedVariant(item.variant);
                              setSelectedImage(item);
                            }}
                          >
                            {/* Video */}
                            <video
                              src={url}
                              className="w-full h-full object-cover"
                              muted
                            />

                            {/* Overlay */}
                            <div className="absolute inset-0 bg-black/30" />

                            {/* Play Icon */}
                            <div className="absolute inset-0 flex items-center justify-center">
                              <div
                                className={`w-6 h-6 ${isDark ? "bg-gray-100" : "bg-white"} rounded-full flex items-center justify-center shadow`}
                              >
                                <div
                                  className="ml-[2px]"
                                  style={{
                                    width: 0,
                                    height: 0,
                                    borderTop: "4px solid transparent",
                                    borderBottom: "4px solid transparent",
                                    borderLeft: "6px solid black",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              {/* Right Panel */}
              <div className="w-full  px-4 md:p-0 lg:rounded-2xl lg:border lg:border-gray-200 lg:bg-white lg:p-5 lg:shadow-sm">
                <h2 className="md:text-lg font-semibold leading-snug">
                  {currentTitle}
                </h2>
                <div className="flex justify-between mt-3 mb-5 items-center">
                  <div className="flex items-center gap-2">
                    <div className="flex text-primary-800 items-center">
                      <p className="md:text-xl font-bold text-lg">
                        {t("TK", language)} {originalPrice}
                      </p>
                    </div>
                    {currentPrice && (
                      <div className="relative text-gray-400 text-sm md:text-base">
                        {t("TK", language)} {currentPrice}
                        <span className="absolute left-0 top-1/2 w-full h-[1px] bg-gray-400"></span>
                      </div>
                    )}
                  </div>

                  <div className="flex items-center gap-2">
                    {discountPercent > 0 && (
                      <div className="px-3 py-1 rounded-full text-white text-xs md:text-sm font-semibold  bg-gradient-to-r from-primary-500 via-primary-600 to-primary-800 shadow-sm">
                        {discountPercent}% OFF
                      </div>
                    )}
                    {freeVariantDelivery === 1 && (
                      <div className="flex items-center gap-1 px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-medium">
                        <FaTruck className="text-sm" />
                        {t("freeDeliveryBadge", language)}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-4 md:mt-3 mt-1">
                  {/* Label */}
                  <p className="text-sm font-medium text-gray-700">
                    {t("quantity", language)}
                  </p>

                  {/* Quantity Controller */}
                  <div className="flex items-center gap-3 bg-gray-50 px-2 py-1 rounded-full shadow-sm">
                    {/* Decrease */}
                    <button
                      onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                      className="w-9 h-9 flex items-center justify-center rounded-full text-red-600 shadow-sm bg-red-50 transition-all duration-200"
                    >
                      −
                    </button>

                    {/* Value */}
                    <span
                      className={`min-w-[30px] text-center text-sm md:text-base font-bold ${isDark ? "text-white" : "text-gray-800"} `}
                    >
                      {quantity}
                    </span>

                    {/* Increase */}
                    <button
                      onClick={() => setQuantity((q) => q + 1)}
                      className="w-9 h-9 flex items-center justify-center rounded-full bg-green-50 text-green-600 shadow-md hover:shadow-lg hover:scale-[1.05] transition-all duration-200"
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="md:mt-6 mt-3 mb-3 p-4 md:p-5 rounded-lg bg-white shadow-sm border border-gray-200">
                  {/* Header */}
                  <div className="flex items-center gap-2 mb-3">
                    <div className="w-1.5 h-5 rounded-full bg-gradient-to-b from-primary-500 via-primary-600 to-primary-800"></div>
                    <h3
                      className={`font-semibold ${isDark ? "text-white" : "text-gray-800"} md:text-lg`}
                    >
                      {t("productDetails", language)}
                    </h3>
                  </div>

                  {/* Description */}
                  <p
                    className={`text-sm md:text-[15px] leading-6 text-gray-600 transition-all whitespace-pre-line ${
                      expanded ? "" : "line-clamp-3"
                    }`}
                  >
                    {product?.description ?? ""}
                  </p>

                  {/* Expand Button */}
                  {product?.description && (
                    <button
                      onClick={() => setExpanded(!expanded)}
                      className="mt-2 text-sm font-medium text-primary-600 transition"
                    >
                      {expanded ? "See less" : "See more"}
                    </button>
                  )}

                  {/* Extra Description */}
                  {product?.extraDescription && (
                    <div className="mt-4 p-3 rounded-lg bg-gray-50 border border-gray-100">
                      <p className="text-sm leading-6 text-gray-600 whitespace-pre-line">
                        {product?.extraDescription}
                      </p>
                    </div>
                  )}
                </div>

                {/* Title Selection */}
                {/* Variant Selection Dropdown */}
                {variants.length > 1 && (
                  <VariantSelector
                    variants={variants}
                    selectedVariant={selectedVariant}
                    setSelectedVariant={setSelectedVariant}
                    setSelectedImage={setSelectedImage}
                  />
                )}
                {sizes.length > 0 && (
                  <div className="mb-4">
                    {/* Label */}
                    <p className="text-sm font-medium text-gray-700 mb-2">
                      {t("size", language)}:{" "}
                      <span className="text-primary-600">{selectedSize}</span>
                    </p>

                    {/* Options */}
                    <div className="flex flex-wrap gap-2">
                      {sizes.map((size) => (
                        <button
                          key={size}
                          onClick={() => setSelectedSize(size)}
                          className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-all duration-200
                            ${
                              selectedSize === size
                                ? "bg-gradient-to-r from-primary-500 via-primary-600 to-primary-800 text-white border-transparent shadow-md scale-[1.05]"
                                : "bg-white text-gray-600 border-gray-200 "
                            }`}
                        >
                          {size}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                {/* Color Selection */}
                <div className="">
                  {colors.length > 0 && (
                    <div className="md:mt-6 mt-3 mb-3 p-4 md:p-5 rounded-lg bg-white shadow-sm border border-gray-200">
                      {/* Header */}
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-1.5 h-5 rounded-full bg-gradient-to-b from-primary-500 via-primary-600 to-primary-800"></div>
                        <h3
                          className={`font-semibold ${isDark ? "text-white" : "text-gray-800"}  md:text-lg`}
                        >
                          {t("color", language)}:{" "}
                        </h3>
                        <div className="flex items-center gap-2">
                          <span
                            className="w-3.5 h-3.5 rounded-full border"
                            style={{
                              backgroundColor: getColorCode(selectedColor),
                            }}
                          />
                          <span
                            style={{
                              color: getColorCode(selectedColor),
                            }}
                            className=" font-medium"
                          >
                            {selectedColor}
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {colors.map((color) => (
                          <button
                            key={color}
                            onClick={() => setSelectedColor(color)}
                            className={`flex items-center gap-2 px-3 py-2 rounded-full border transition-all duration-200 ${
                              selectedColor === color
                                ? "border-gray-900 bg-gray-100 shadow-md"
                                : "border-gray-300 hover:border-gray-500"
                            }`}
                          >
                            {/* Color Circle */}
                            <span
                              className="w-5 h-5 rounded-full border "
                              style={{
                                backgroundColor: getColorCode(color),
                                border: getColorCode(color),
                              }}
                            />

                            {/* Color Name */}
                            <span
                              className="text-sm font-medium "
                              style={{ color: getColorCode(color) }}
                            >
                              {color}
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="gap-2 mt-5 mb-3 hidden sm:flex">
                    <button
                      type="button"
                      onClick={handleAddToCart}
                      className="flex-1 flex items-center justify-center gap-2 border border-gray-300 text-gray-700  bg-white rounded-xl md:py-3 py-2 text-sm md:text-base font-medium shadow-sm hover:shadow-md hover:border-[#FF4747] hover:text-[#FF4747] transition-all duration-300"
                    >
                      🛒 {t("addToCart", language)}
                    </button>

                    <button
                      type="button"
                      onClick={handleOrderNow}
                      className="flex-1 flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-primary-500 via-primary-600 to-primary-800 text-white md:py-3 py-2 text-sm md:text-base font-semibold shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 animate-pulse"
                    >
                      {t("orderNow", language)}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6">
              <ProblemAndDelivery whatsappMessage={whatsappMessage} />
            </div>
          </div>
          <div className="fixed bottom-[56px] left-0 w-full z-50 bg-white border-t border-slate-200 gap-2 px-5 py-2 sm:hidden flex">
            <button
              type="button"
              onClick={handleAddToCart}
              className={`flex-1 flex items-center justify-center gap-2  border border-gray-300 text-gray-700 ${isDark ? "bg-gray-100" : "bg-white"} rounded-full md:py-3 py-2 text-sm md:text-base font-medium shadow-sm hover:shadow-md hover:border-[#FF4747] hover:text-[#FF4747] transition-all duration-300`}
            >
              🛒 {t("addToCart", language)}
            </button>

            <button
              type="button"
              onClick={handleOrderNow}
              className="flex-1 flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-primary-500 via-primary-600 to-primary-800 text-white md:py-3 py-2 text-sm md:text-base font-semibold shadow-md hover:shadow-lg hover:scale-[1.02] transition-all duration-300 animate-pulse"
            >
              ⚡ {t("orderNow", language)}
            </button>
          </div>
          {/* Related Products */}
          <div className="mt-3 pb-8">
            <ProductSwiper
              data={products}
              loading={loading}
              link=""
              title={t("youMayLike", language)}
              icon=""
            />
          </div>
        </div>
        {/*<ScrollToTopButton />*/}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {/*<FooterSection />*/}
      </div>
    </div>
  );
};

export default ProductDetails;
